import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonFunctionService, UserMerchantData } from '../Common/common-function.service';
import { CouponRequest } from 'src/app/models/coupon-request';
import { Coupons } from 'src/app/models/coupons';
import { catchError, map } from 'rxjs';

@Injectable()
export class CouponsService {
  token;
  headers: any;
  constructor(private service: DataService, private http: HttpClient, private common: CommonFunctionService) {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));
  }

  GetCoupons(data) {
    this.GetHeaderdetails();
    return this.http.get<CouponRequest>(environment.getCoupons + "?MerchantKeyId=" + data, { headers: this.headers })
    .pipe(map(response => response),catchError(this.common.handleError));
  }
  GetCouponByCouponCode(data, Email) {
    this.GetHeaderdetails();
    return this.http.get<CouponRequest>(environment.GetCouponByCouponCode + "?CouponCode=" + data + "&Email=" + Email, { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }

  AddCoupons(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post(environment.addcoupon + "?MerchantKeyId=" + merchantdata.MerchantKeyId, data, { headers: this.headers });
  }

  GetCouponDetail(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.GetCouponCodedetails + "?MerchantKeyId=" + data.merchantKeyId + "&code=" + data.Code + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers })
      .pipe(map(response => response),catchError(this.common.handleError));
  }
  // ViewCoupon(data,Email)
  // {
  //   return this.http.get(environment.ViewCoupons+"?id="+data+"&Email=" +Email)  
  //   .map(response => response) .catch(this.common.handleError);
  // } 

  // deleteCoupon(data,Email)
  // {

  //  return this.http.get<CouponRequest>(environment.DeleteCoupons+"?id="+data+"&Email=" +Email);

  // }

  AddProductssToCouponCode(data1, data2, data3, Email) {
    this.GetHeaderdetails();
    return this.service.create(environment.AddProductsToCouponCode + '?CouponCodes=' + data1 + '&ProductCode=' + data2 + '&MerchantKeyId=' + data3 + '&Email=' + Email, { headers: this.headers });
  }
  ViewCoupon(couponid, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.Viewcoupon + "?id=" + couponid + "&MerchantKeyId=" + merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
    // .map(response => response)   
    // .catch(this.common.handleError);   
  }
  getcoupondetails(couponid, merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<Coupons>(environment.getcoupondetails + "?MerchantKeyId=" + merchantKeyId + "&code=" + couponid + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });


  }


  getcoupons(merchantKeyId) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<Coupons>(environment.getcoupons + "?MerchantKeyId=" + merchantKeyId + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });
  }


  deletecoupon(data) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.post<Coupons>(environment.Deletecoupon + "?MerchantKeyId=" + merchantdata.MerchantKeyId, data, { headers: this.headers });

  }
  viewCouponcodeFilterdataurl(MerchantKeyId, Fromdate1, todate1, TransactionId, cartid, Amount, amountcompare) {
    this.GetHeaderdetails();
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    return this.http.get<any>(environment.viewCouponcodeFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1
      + "&TransactionId=" + TransactionId + "&Cartid=" + cartid + "&Amount=" + Amount + "&AmountCheck=" + amountcompare + "&LoginUserId=" + merchantdata.UserId
      , { headers: this.headers });

  }
  CouponFilterdataurl(data) {
    this.GetHeaderdetails();
    // const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    // return this.http.get<any>(environment.CouponFilterdataurl + "?MerchantKeyId=" + MerchantKeyId + "&fromdate=" + Fromdate1 + "&todate=" + todate1 + "&CouponCode=" + CCode + "&CouponValue=" + CValue + "&CouponType=" + CType + "&AmountCheck=" + amountcompare + "&UserId=" + loggedinuseremail
    //   + "&LoginUserId=" + merchantdata.UserId, { headers: this.headers });
      return this.http.post<any>(environment.CouponFilterdataurl,data,{headers:this.headers});
  }
  GetHeaderdetails() {
    let loggedUsername = this.common.getUserName()
    const merchantdata: UserMerchantData = this.common.getUserMerchantData();
    this.token = environment.GetAuthenticationToken + ":" + this.common.GetAuthToken() + ":" + "IT" + ":" + environment.GetAuthencticationKey + ":" + this.common.getSid() + ":" + merchantdata.MerchantKeyId;
    this.headers = new HttpHeaders().
      set('Authorization', 'basic ' + btoa(this.token));


  }
}
